/** GET — `apiV8nocache` base is already `/api/v8`. */
const STUDENTS_REPORT_API_PATH = "/pbis/reports/students"
const STUDENTS_REPORT_EXPORT_API_PATH = "/pbis/reports/students/export"
const STAFF_STUDENT_POINTS_SUMMARY_API_PATH = "/pbis/students"
const STAFF_STUDENT_POINTS_TRANSACTIONS_SUFFIX = "/points/transactions"
const STAFF_STUDENT_POINTS_TRANSACTIONS_EXPORT_SUFFIX =
  "/points/transactions/export"
const STAFF_STUDENT_POINTS_SUMMARY_SUFFIX = "/points/summary"

export default {
  STUDENTS_REPORT_API_PATH,
  STUDENTS_REPORT_EXPORT_API_PATH,
  STAFF_STUDENT_POINTS_SUMMARY_API_PATH,
  STAFF_STUDENT_POINTS_TRANSACTIONS_SUFFIX,
  STAFF_STUDENT_POINTS_TRANSACTIONS_EXPORT_SUFFIX,
  STAFF_STUDENT_POINTS_SUMMARY_SUFFIX
}
